var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVideoDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:outline-insert-frame"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5613",
    x: 3.48621,
    y: 5.19141,
    width: 14,
    height: 14,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 48096213"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5614",
    x: 6.48621,
    y: 13.1914,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5616",
    x: 11.4862,
    y: 13.1914,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5615",
    x: 6.48621,
    y: 8.19141,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5617",
    x: 11.4862,
    y: 8.19141,
    width: 3,
    height: 3,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M16.9862 11.9082L22.9862 6.4082L22.9862 17.4082L16.9862 11.9082Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoDownload);
export default __webpack_public_path__ + "static/media/icon-video-download.7fbc80d81d3270dab053b43e0ef05494.svg";
export { ForwardRef as ReactComponent };